import * as React from 'react'
import { Input as InputPrimitive } from '@base-ui/react/input'

import cn from '@config/tailwind/cn'

import { typographyVariants } from '../lib'

function Input({
  className,
  type,
  size = 'default',
  ...props
}: Omit<React.ComponentProps<'input'>, 'size'> & {
  size?: 'sm' | 'default'
}) {
  return (
    <InputPrimitive
      type={type}
      data-slot='input'
      data-size={size}
      className={cn(
        'ui:border-outline ui:focus-visible:border-blue-100 ui:focus-visible:ring-blue-20 ui:aria-invalid:ring-error-container ui:aria-invalid:border-error ui:disabled:bg-grey-10 ui:data-[size=default]:h-12 ui:data-[size=sm]:h-8 ui:rounded-lg ui:data-[size=sm]:rounded-[min(var(--radius-md),10px)] ui:border ui:bg-neutral-white ui:px-2.5 ui:py-1 ui:transition-colors ui:file:h-12 ui:data-[size=sm]:file:h-8 ui:file:font-medium ui:focus-visible:ring-[3px] ui:aria-invalid:ring-[3px] ui:placeholder:text-grey-60 ui:w-full ui:min-w-0 ui:outline-none ui:file:inline-flex ui:file:border-outline ui:file:bg-neutral-white ui:disabled:pointer-events-none ui:disabled:cursor-not-allowed ui:disabled:opacity-50 ui:text-neutral-black',
        typographyVariants({ variant: 'body-lg' }),
        className,
      )}
      {...props}
    />
  )
}

export { Input }
